export const calculateSelectedTotal = (lineItems) => {
  return lineItems.reduce((total, x) => total + (x.isSelected ? x.quotedPrice : 0), 0)
}

export const updateProgressBasedPaymentAmounts = (lineItems, paymentSchedules, totalPriceWithoutSalesTax) => {
  const updatedPaymentSchedules = paymentSchedules.map(schedule => {
    return {
      ...schedule,
      amount: lineItems.reduce((total, x) => total + (x.isSelected ? Math.round(x.quotedPrice * schedule.percentage) : 0), 0)
    }
  })  
  const sum = updatedPaymentSchedules.reduce((total, x) => total + x.amount, 0)
  const difference = totalPriceWithoutSalesTax - sum
  updatedPaymentSchedules[updatedPaymentSchedules.length - 1].amount += difference
  return updatedPaymentSchedules
}

export const calculateSalesTax = (lineItems) => {
  return lineItems.reduce((total, x) => total + (x.isSelected ? x.estimatedSalesTax : 0), 0)
}

export const anySalesTax = (lineItems) => {
  return lineItems.some(x => x.estimatedSalesTax > 0)
}

export const calculatePerInvoiceAmounts = (lineItems, totalPayments) => {
  const totalPriceWithoutSalesTax = calculateSelectedTotal(lineItems)
  const totalSalesTax = calculateSalesTax(lineItems)
  const totalPriceWithSalesTax = totalPriceWithoutSalesTax + totalSalesTax
  const perInvoiceWithoutSalesTax = Math.round(totalPriceWithoutSalesTax / totalPayments)
  const perInvoice = Math.round(totalPriceWithSalesTax / totalPayments)
  const salesTaxPerInvoice = perInvoice - perInvoiceWithoutSalesTax

  return { perInvoice, salesTaxPerInvoice, totalPriceWithSalesTax }
}

export const getWorkareaIdsFromSelectedLineItems = (lineItems) => {
  return lineItems.flatMap(x => x.isSelected ? x.workareaIds : [])
}

const nthWeekMap = {
  'first': 'First',
  'second': 'Second',
  'third': 'Third',
  'fourth': 'Fourth'
}

export const buildRecurringPaymentText = (recurringPayment) => {
  if (recurringPayment.hideScheduleOnProposal) {
    return ''
  }

  if (recurringPayment.invoiceEveryUnit === 'weeks') {
    const weeks = recurringPayment.invoiceEvery === 1 ? 'Week' : `${recurringPayment.invoiceEvery} Weeks`
    return `Invoice Every ${weeks} on ${recurringPayment.weeklyRepeatOn}`
  }

  const months = recurringPayment.invoiceEvery === 1 ? 'Month' : `${recurringPayment.invoiceEvery} Months`
  const when = recurringPayment.monthlyOption === 'day'
    ? `Day ${recurringPayment.monthlyRepeatOnDay}`
    : `the ${nthWeekMap[recurringPayment.monthlyRepeatEveryNthWeek]} ${recurringPayment.monthlyRepeatOn}`
  return `Invoice Every ${months} on ${when}`
}
